import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import React from "react";
import routeConstants from "utils/routeConstants";

const links: SectionLandingLink[] = [
  {
    title: "Generation by fuel type",
    to: routeConstants.generationByFuelType,
    description:
      "The Generation By Fuel type report provides our users with an indication of the generation outturn for Great Britain.",
  },
  {
    title: "Interconnector flows",
    to: routeConstants.interconnectorFlows,
    description:
      "The Interconnector flows report is derived from the Generation by Fuel Type data and shows both " +
      "interconnector imports and exports.",
  },
  {
    title: "Generation forecast",
    to: routeConstants.generationForecast,
    description:
      "NESO creates a forward view of availability (also referred to as Output Usable data " +
      "under the Grid Code) for generation and interconnector capacity, accounting for planned outages.",
  },
  {
    title: "Generation forecast for wind & solar",
    to: routeConstants.generationForecastForWindAndSolar,
    description:
      "A forecast of wind and solar power generation (MW) per bidding zone, per Settlement Period of the following day",
  },
  {
    title: "Wind generation",
    to: routeConstants.windGeneration,
    description:
      "NESO uses its wind power forecasting tool to produce hourly forecast for period from " +
      "20:00 (GMT) on the current day (D) to 20:00 (GMT) (D+2).",
  },
  {
    title: "Actual aggregated generation per type",
    to: routeConstants.actualGenerationPerType,
    description:
      "Actual aggregated net generation output (MW) per Settlement Period and per production type.",
  },
  {
    title: "Actual or estimated wind and solar power generation",
    to: routeConstants.actualOrEstimatedWindAndSolarPowerGeneration,
    description:
      "Actual or estimated net wind and solar power generation (MW) in each bidding zone per Settlement Period.",
  },
  {
    title: "Day-ahead aggregated generation",
    to: routeConstants.dayAheadAggregatedGeneration,
    description:
      "An estimate of the total net scheduled generation (MW) per bidding zone, per Settlement Period of the following day.",
  },
];

const Generation: React.FC = () => (
  <SectionLandingPage
    title="Generation"
    description={
      <>
        <p>
          The Generation data provides insights into electricity generation for
          Great Britain.
        </p>
        <p>
          View generation by fuel type, monitor interconnector flows, and assess
          how forecasts align with actual outputs. From detailed insights into
          wind and solar production to day-ahead projections, this section
          provides data illustrating how the energy system is powered today and
          how it is expected to change.
        </p>
      </>
    }
    links={links}
  />
);

export default Generation;
